import React, { useContext, useEffect, useState } from 'react'
import popupStyle from "../../../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss";
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import contactStyles from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"
import waCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import fieldStyles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss' 
import textAreaStyles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import { Autocomplete, Chip, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography, useMediaQuery } from '@mui/material';
import GlobalButton from '../../../../../utility/globalButton/button';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { customVariableConditions, operatorType } from '../../../../../../models/flowBuilderTypes';
import { checkValidRegex, generateUUID } from '../../../../../../utils/constants';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import CloseIcon from '@mui/icons-material/Close';
import { previousDay } from 'date-fns';
import { operatorTypesBlockForVariableToVariable, operatorTypesWithEmptyValue } from '../../../flowBuilderConstants';

const CustomVarConditionPopup = (props: any) => {

    const { actionData, stepAction, setVariableConditionPopup } = props;
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const { operatorList, getOperatorTypeApi, currentActiveNodeConfig, nodes, setNodes, edges, setUpdatedEdges } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { currentActiveStaticWorkflow} = useContext(WorkflowContext) as WorkflowContextPayload;

    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');

    const [payload, setPayload] = useState<customVariableConditions>({
        chatbot_custom_variable_configuration_id: "",
        operator_type_id: "",
        operator_type_name: "",
        condition_value: "",
        unique_id: generateUUID(),
        flag_compare_with_static_value: true, 
        rhs_chatbot_custom_variable_configuration_id: "",
    }) 
    const [typedConditionValue, setTypedConditionValue] = useState<string>("");

    const getOperatorTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOperatorTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const checkIsSameConditionExist = () => {
        for (let i = 0; i < nodes.length; ++i) {
            if (nodes[i].id == currentActiveNodeConfig.nodeId) {
                for (let j = 0; j < nodes[i].data.length; ++j) {
                    if ((nodes[i]?.data?.[j]?.action_data?.chatbot_custom_variable_configuration_id == payload.chatbot_custom_variable_configuration_id) && (nodes[i]?.data?.[j]?.action_data?.condition_value == payload.condition_value) && (nodes[i]?.data?.[j]?.action_data?.operator_type_id == payload.operator_type_id) && (nodes[i]?.data[j]?.chatbot_step_action_id != stepAction.chatbot_step_action_id)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    const disabledSaveBtn = () => {
        if (payload.chatbot_custom_variable_configuration_id?.length > 0 && payload.operator_type_id?.length > 0 && payload.operator_type_name?.length > 0) {  

            if(!payload.flag_compare_with_static_value){
                if(payload.rhs_chatbot_custom_variable_configuration_id?.length == 0){
                    return true;
                }
            } else {
                if(!operatorTypesWithEmptyValue.includes(payload.operator_type_name?.toLowerCase())){
                    if(payload.condition_value?.trim()?.length == 0){
                        return true;
                    }
                }
            }

            if(payload.operator_type_name?.toLowerCase() == "regex match"){
                if(!checkValidRegex(payload.condition_value)){
                    return true;
                }
            }
            return checkIsSameConditionExist();
        }
        return true;
    }

    const getTagretForCondition = () => {
        const currentEdge = edges?.find((edge: any) => {
            return edge?.sourceHandle == getSourcehandleForCondition();
        }); 
        if(currentEdge){
            return currentEdge?.target;
        } 
        return "";
    }

    const getEdgeObjectForCondition = () => {
        return {
            source: currentActiveNodeConfig?.nodeId, 
            sourceHandle: getSourcehandleForCondition(),
            target: getTagretForCondition(),
            targetHandle: getTagretForCondition(),
            isCustomVariable: true
        }
    }

    const updateConditionFlow = (updatedNodes: any) => {
        setTimeout(() => {
            setUpdatedEdges({
               actionType: "addNewEdge",
               edgeData: getEdgeObjectForCondition(),
           },
               updatedNodes,
               edges,
               true
           );
        }, 1200);
    }

    const getSourcehandleForCondition = () => {
        return (actionData?.chatbot_custom_variable_configuration_id && actionData?.operator_type_id && actionData?.unique_id) ? `${actionData?.unique_id}+${actionData?.chatbot_custom_variable_configuration_id}+${actionData?.operator_type_id}` : ""
    }

    const checkIfConditionFlowIsExistOrNot = () => {
        return edges?.find((edge: any) => {
            return edge?.sourceHandle == getSourcehandleForCondition();
        })
    }

    const handleSaveClick = () => {
        const updatedNodes = nodes?.map((node: any) => {
                if (node.id == currentActiveNodeConfig.nodeId) {
                    return {
                        ...node,
                        data: node.data.map((action: any) => {
                            if (action.chatbot_step_action_id == stepAction.chatbot_step_action_id) {
                                return {
                                    ...action,
                                    action_data: payload,
                                }
                            }
                            return action;
                        })
                    }
                }
                return node;
            })
        setNodes(updatedNodes); 

        if(actionData.chatbot_custom_variable_configuration_id && checkIfConditionFlowIsExistOrNot()){
            updateConditionFlow(updatedNodes);
        }

        setVariableConditionPopup(false);
    }

    useEffect(() => {
        if (!operatorList) {
            getOperatorTypeApiCall();
        }
        if (actionData.chatbot_custom_variable_configuration_id) {
            setPayload((prev) => ({
                ...prev,
                chatbot_custom_variable_configuration_id: actionData.chatbot_custom_variable_configuration_id,
                operator_type_id: actionData.operator_type_id,
                operator_type_name: actionData.operator_type_name,
                condition_value: actionData.condition_value,
                unique_id: actionData?.unique_id, 
                flag_compare_with_static_value: actionData?.rhs_chatbot_custom_variable_configuration_id ? false : true,
                rhs_chatbot_custom_variable_configuration_id: actionData?.rhs_chatbot_custom_variable_configuration_id,
            }));
        }
    }, []); 

    const checkDisableValueField = () => { 
        if(operatorTypesWithEmptyValue.includes(payload.operator_type_name?.toLowerCase())){
            return true;
        }
        return false;
    }

    const getOperatorOptionList = () => {
        if(!payload.flag_compare_with_static_value){
            return operatorList?.filter((operator) => operator.is_active)?.filter((operator) => (!operatorTypesWithEmptyValue?.includes(operator?.operator_type_name?.toLowerCase()) && !operatorTypesBlockForVariableToVariable?.includes(operator?.operator_type_name?.toLowerCase()))) ?? []; 
        }
        return operatorList?.filter((operator) => operator.is_active) ?? [];

    }

    return (
        <>
            <Grid container className={`${globalStyles.fullHeight} ${globalStyles.zIndex1} ${globalStyles.flexColumn}`} gap={"20px"} padding={"30px"} flexWrap={"nowrap"}>
                <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                    <span className={popupStyle.popupTitleStyle}>Condition</span>
                </Grid>
                <Grid item>
                    <Divider style={{ opacity: "0.2", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container gap={1}>
                        <Grid item xs={12}>
                            <Typography className={styles.createWorkflowLabelStyle}>Compare with</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue=""
                                    name="radio-buttons-group"
                                    value={payload.flag_compare_with_static_value}
                                    onChange={(event) => { 
                                        setPayload((prev) => {
                                            const updatedPayload = {
                                                ...prev, 
                                                flag_compare_with_static_value: event.target.value == "true",
                                                condition_value: "", 
                                                rhs_chatbot_custom_variable_configuration_id: "", 
                                            }

                                            if(operatorTypesWithEmptyValue?.includes(updatedPayload.operator_type_name?.toLowerCase())){
                                                updatedPayload.operator_type_id = "";
                                                updatedPayload.operator_type_name = "";
                                            }
                                            return updatedPayload;
                                        })
                                    }}
                                >
                                    <FormControlLabel className={globalStyles.radioLabelStyle} value={true} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} control={<Radio className={globalStyles.radioButton} />} label="A Static Value" />
                                    <FormControlLabel className={globalStyles.radioLabelStyle} value={false} disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} control={<Radio className={globalStyles.radioButton} />} label="A Variable" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`}>
                    <Grid container flexWrap={"nowrap"} gap={"10px"}>
                        <Grid item xs={operatorTypesWithEmptyValue?.includes(payload?.operator_type_name?.toLowerCase()) ? 6 : 4.5}>
                            <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                <Grid item>
                                    <Typography className={styles.createWorkflowLabelStyle}>Variable</Typography>
                                </Grid>
                                <Grid>
                                    <Autocomplete
                                        className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                        options={customVariableList?.custom_variable_data || []}
                                        getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                        value={customVariableList?.custom_variable_data?.find((variable: customVariableDataInterface) => variable.chatbot_custom_variable_configuration_id == payload.chatbot_custom_variable_configuration_id) || null}
                                        onChange={(_, value: customVariableDataInterface | null) => {
                                            setPayload((prev) => ({
                                                ...prev,
                                                chatbot_custom_variable_configuration_id: value ? value?.chatbot_custom_variable_configuration_id : "",
                                            }));
                                        }}
                                        renderInput={(params) => <TextField {...params} placeholder='Select Variable' />} 
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={operatorTypesWithEmptyValue?.includes(payload?.operator_type_name?.toLowerCase()) ? 6 : 3}>
                            <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                <Grid item>
                                    <Typography className={styles.createWorkflowLabelStyle}>Operator</Typography>
                                </Grid>
                                <Grid>
                                    <Autocomplete
                                        className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                        options={getOperatorOptionList()}
                                        getOptionLabel={(option) => option.operator_type_name}
                                        value={operatorList?.filter((operator) => operator.is_active).find((operator) => operator.operator_type_id == payload.operator_type_id) || null}
                                        onChange={(_, value: operatorType | null) => {
                                            setPayload((prev) => {
                                                const updatedPayload = {
                                                    ...prev,
                                                    operator_type_id: value ? value.operator_type_id : "",
                                                    operator_type_name: value ? value.operator_type_name : "",
                                                };
                                                if(value && operatorTypesWithEmptyValue.includes(updatedPayload.operator_type_name?.toLowerCase())) {
                                                    updatedPayload.condition_value = "";
                                                }
                                                return updatedPayload;
                                            });

                                        }}
                                        renderInput={(params) => <TextField {...params} placeholder='Operator' />}
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid> 
                        {payload.flag_compare_with_static_value ? 
                            !operatorTypesWithEmptyValue?.includes(payload?.operator_type_name?.toLowerCase()) && 
                                <Grid item xs={4.5}>
                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                        <Grid item>
                                            <Typography className={styles.createWorkflowLabelStyle}>Value</Typography>
                                        </Grid>
                                        <Grid>
                                            {payload?.operator_type_name?.toLowerCase() == "contains in array" ?
                                                <Autocomplete   
                                                    className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${fieldStyles.triggerValueFreeSolo} ${styles.conditionValueFreeSolo}`}
                                                    freeSolo
                                                    options={[]}
                                                    multiple
                                                    value={payload.condition_value?.split(",")?.map((item) => item?.trim())?.filter((item) => item?.length > 0) ?? []}
                                                    inputValue={typedConditionValue} 
                                                    onInputChange={(e, val) => {
                                                        setTypedConditionValue(val);
                                                    }}
                                                    renderTags={(value, getTagProps) =>
                                                        value.map((option, index) => (
                                                            <Chip
                                                                label={option}
                                                                deleteIcon={<CloseIcon />}
                                                                {...getTagProps({ index })}
                                                                sx={{
                                                                    whiteSpace: "normal", 
                                                                    wordBreak: "break-word",
                                                                    padding: "4px 0px",
                                                                    height: "auto",
                                                                }}
                                                            />
                                                        ))
                                                    }
                                                    onChange={(e, newValue) => { 
                                                        const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                                        setPayload((prev) => ({
                                                            ...prev,
                                                            condition_value: filtered?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "",
                                                        }))
                                                    }} 
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisableValueField()}
                                                    renderInput={params => {
                                                        const { InputProps, ...restParams } = params;
                                                        const { startAdornment, ...restInputProps } = InputProps;
                                                        return (
                                                            <TextField
                                                                {...restParams}
                                                                placeholder='Enter Value' 
                                                                onBlur={() => {
                                                                    if(typedConditionValue.trim()?.length > 0){ 
                                                                        const currentVal = payload.condition_value?.split(",")?.map((item) => item?.trim())?.filter((item) => item?.length > 0) || [];
                                                                        if(!currentVal.find((val) => val == typedConditionValue.trim())){
                                                                            const newVal = [...currentVal, typedConditionValue.trim()];
                                                                            setPayload((prev) => ({
                                                                                ...prev,
                                                                                condition_value: newVal?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "",
                                                                            }))
                                                                            setTypedConditionValue(""); 
                                                                        }
                                                                    }
                                                                }}
                                                                InputProps={{
                                                                    ...restInputProps,
                                                                    startAdornment: (
                                                                        <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                            {startAdornment}
                                                                        </div>
                                                                    ),
                                                                }}
                                                            />
                                                        );
                                                    }}
                                                />
    
                                                :
                                                <textarea
                                                    // rows={1}
                                                    value={payload.condition_value}
                                                    onChange={(e) => {
                                                        setPayload((prev) => ({
                                                            ...prev,
                                                            condition_value: e.target.value,
                                                        }))
                                                    }}
                                                    placeholder="Enter Value"
                                                    className={`${textAreaStyles.templateGlobalTextarea} ${styles.conditionValueTextArea}`} 
                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisableValueField()}
                                                />
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>
                            
                            : 
                            <Grid item xs={4.5}>
                                <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                    <Grid item>
                                        <Typography className={styles.createWorkflowLabelStyle}>Variable</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Autocomplete
                                            className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                            options={customVariableList?.custom_variable_data || []}
                                            getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                            value={customVariableList?.custom_variable_data?.find((variable: customVariableDataInterface) => variable.chatbot_custom_variable_configuration_id == payload.rhs_chatbot_custom_variable_configuration_id) || null}
                                            onChange={(_, value: customVariableDataInterface | null) => {
                                                setPayload((prev) => ({
                                                    ...prev,
                                                    rhs_chatbot_custom_variable_configuration_id: value ? value?.chatbot_custom_variable_configuration_id : "",
                                                }));
                                            }}
                                            renderInput={(params) => <TextField {...params} placeholder='Select Variable' />} 
                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <Grid item className={`${globalStyles.fullwidth}`} mt={1}>
                    <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Cancel"}
                                className='borderedButtonStyle'
                                sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    setVariableConditionPopup(false);
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Save"}
                                className='primaryButtonStyle'
                                sx={{ minWidth: "130px" }}
                                disabled={disabledSaveBtn() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                onClick={() => {
                                    handleSaveClick();
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CustomVarConditionPopup
